import { keyframes, styled } from "styled-components";
import ProgressiveImg from "../../components/ProgressiveImg/ProgressiveImg";
import { ReactComponent as GiftSvg } from "../../assets/icons/gift.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as GiftEmpty } from "../../assets/icons/gift-empty.svg";
import InfiniteScroll from "react-infinite-scroll-component";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const StyledInfinityScroll = styled(InfiniteScroll)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
`;

export const StyledInfinityScrollSearch = styled(InfiniteScroll)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const InfiniteContainer = styled.div`
  overflow-y: scroll;
`;

export const LoaderContainer = styled.div`
  background: white;
  height: calc(100dvh - 122px);
  width: 100%;
`;
export const HomePageContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  background: #fff;
  padding: 10rem 2rem 5rem 2rem;
  gap: 1rem;
  min-height: calc(100dvh - 122px);

  animation: ${(props) => (props.$open ? fadeIn : fadeOut)} 0.3s ease-in-out;
`;
export const CreateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-top: 3rem;
  min-width: 517.2px;
  min-height: 4rem;
  @media (max-width: 946px) {
    flex-direction: column;
  }
  @media (max-width: 590px) {
    min-width: 100%;
  }
`;

export const CloseIcon = styled(Close)`
  fill: #85a1ac;
  cursor: pointer;
  min-width: 2rem;
  margin-left: -1rem;
  &:hover {
    fill: red;
  }
`;
export const ModalCloseIcon = styled(Close)`
  fill: #85a1ac;
  cursor: pointer;
  min-width: 2rem;
  position: absolute;
  top: 2rem;
  right: 2rem;
  &:hover {
    fill: red;
  }
`;
export const Text2 = styled.h3`
  user-select: none;
  color: #85a1ac;
  text-align: center;
  font-family: "FrankfurterEF";
  font-size: 50px;
  font-weight: 500;
  line-height: 32px; /* 64% */
  @media (max-width: 1100px) {
    text-align: center;
  }
  @media (max-width: 615px) {
    font-size: 48px;
  }
  @media (max-width: 410px) {
    font-size: 32px;
  }
`;

export const Sponsors = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
`;

export const SectionTwo = styled.div`
  width: 1440px;
  height: 60vh;
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;
  gap: 30px;
  flex-direction: column;
  padding: 2rem;

  @media (max-width: 1300px) {
    width: 100%;
  }

  @media (max-width: 602px) {
    height: unset;
  }
`;

export const SectionTwoContainer = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const SponsorImgFirst = styled.img`
  user-select: none;
`;
export const SponsorImg = styled(SponsorImgFirst)`
  @media (max-width: 600px) {
    width: ${(props) => (props.$small ? "250px" : "100%")};
    max-height: 175px;
  }
`;

export const HomeContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  min-height: auto;
`;

export const HeaderWrapper = styled.header`
  background: #85a1ac;
  z-index: 500;
  position: fixed;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const BackContainer = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  gap: 1rem;
  padding-left: 2rem;
`;
export const BackRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
  background-color: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(5px);
  margin-left: -2rem;
  margin-top: -1rem;
  padding: 1rem 2rem;
  border-radius: 0rem 1rem 1rem 0rem;
`;
export const BackText = styled.span`
  color: #85a1ac;
  cursor: pointer;
  user-select: none;
  font-family: "Avenir-Heavy";
  font-size: 16px;
  text-transform: uppercase;
  margin-bottom: -2px;
  text-shadow: 0px 0px 3px white;
`;
export const Wrapper = styled.div`
  width: 1440px;
  flex-direction: column;
  display: flex;
  gap: 2rem;
  padding: 2rem;
  @media (max-width: 738px) {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 110px;
  width: 61rem;
  @media (max-width: 1100px) {
    gap: 50px;
  }
  @media (max-width: 615px) {
    width: 100%;
  }
`;
export const GiftIcon = styled.div`
  align-self: center;
  transform: rotate(18.884deg);

  display: none;
`;

export const H1 = styled.h1`
  color: #85a1ac;
  width: 550px;
  user-select: none;
  font-family: "Avenir-Black";
  font-size: 64px;
  text-transform: uppercase;
  text-align: center;
  @media (max-width: 1100px) {
    text-align: center;
  }
  @media (max-width: 615px) {
    font-size: 48px;
    width: 100%;
  }
  @media (max-width: 410px) {
    font-size: 32px;
  }
`;
export const StyledH1 = styled.h1`
  color: #fff;

  user-select: none;
  font-family: "Avenir-Book";
  font-size: 64px;
  @media (max-width: 1100px) {
    text-align: center;
  }
  @media (max-width: 615px) {
    font-size: 48px;
  }
  @media (max-width: 410px) {
    font-size: 32px;
  }
`;

export const Text = styled.h2`
  user-select: none;
  font-family: ${(props) => (props.$bold ? "Avenir-Black" : "Avenir-Medium")};
  color: ${(props) => (props.$bold ? "#85a1ac" : "black")};
  text-transform: ${(props) => (props.$bold ? "uppercase" : "unset")};
  font-size: ${(props) => (props.$bold ? "24px" : "20px")};
  margin-top: ${(props) => (props.$bold ? "20px" : "0px")};
  @media (max-width: 511px) {
    text-align: center;
  }
`;
export const StyledText = styled(Text)`
  opacity: 0.5;
  text-align: center;
  font-size: 1.6rem;
`;

export const TextLight = styled.textarea`
  user-select: none;
  font-family: "Avenir-Medium";
  font-size: 13px;
  letter-spacing: -0.2px;
  color: #85a1ac;
  border: ${(props) =>
    props.$edit ? "1px solid #85a1ac" : "1px solid transparent"};
  background-color: white;
  transition: all 0.3s ease-in-out;
  height: fit-content;
  padding: ${(props) => (props.$edit ? "1rem" : "0rem")};
  border-radius: ${(props) => (props.$edit ? "1rem" : "0rem")};
  max-width: 33rem;
  white-space: break-spaces;
  outline: none;
  height: 10rem;

  @media (max-width: 511px) {
    text-align: center;
  }
  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 35.7rem;
  @media (max-width: 738px) {
    align-items: center;
  }
  @media (max-width: 420px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 21px;
  @media (max-width: 1100px) {
    justify-content: center;
  }
  @media (max-width: 615px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const SearchInput = styled.input`
  width: 45rem;
  padding: 0.5rem 1.5rem;
  border-radius: ${(props) =>
    props.$borderRadius ? "15px 15px 0px 0px" : "1.5rem"};
  outline: none;
  border: 1px solid #85a1ac;

  height: 4rem;

  font-size: 1.8rem;
  transition: all 0.3s ease-in-out;
  font-family: "Avenir-Medium";
  @media (max-width: 738px) {
    width: 30rem;
  }
  @media (max-width: 350px) {
    width: 25rem;
  }
`;

export const Input = styled.input`
  width: 45rem;
  padding: 0.5rem 1.5rem;
  border-radius: ${(props) =>
    props.$borderRadius ? "15px 15px 0px 0px" : "1.5rem"};
  outline: none;
  border: 1px solid #85a1ac;

  height: 4rem;

  font-size: 1.8rem;
  transition: all 0.3s ease-in-out;
  font-family: "Avenir-Medium";

  @media (max-width: 420px) {
    width: 90% !important;
  }
`;
export const CloseIconRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
`;
export const Button = styled.button`
  display: flex;
  flex-direction: row;
  user-select: none;
  margin-top: ${(props) => (props.$marginTop ? "3rem" : "0rem")};
  align-items: center;
  background: ${(props) => (props.$disabled ? "#f0f0f0" : "#85a1ac")};
  box-shadow: ${(props) =>
    props.$noShadow
      ? "none"
      : "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;"};
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  min-width: 75px;
  height: 25px;
  gap: 1rem;
  justify-content: center;
  border: none;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  color: ${(props) => (!props.$disabled ? "#f0f0f0" : "#85a1ac")};
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 12px;
  letter-spacing: -0.2px;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  padding: 0.5rem 1.5rem;
  outline: none;

  &:active {
    scale: ${(props) => (props.$disabled ? "1 !important" : 0.95)};
    box-shadow: none;
  }
`;

export const StyledButton = styled(Button)`
  font-size: 16px;
  white-space: nowrap;
  height: 3rem;
`;

export const ButtonDisabled = styled.button`
  display: flex;
  flex-direction: row;
  user-select: none;
  align-items: center;
  background: #85a1ac;
  box-shadow: ${(props) =>
    props.$noShadow
      ? "none"
      : "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;"};
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  min-width: 75px;
  height: 25px;
  gap: 1rem;
  justify-content: center;
  border: none;
  cursor: not-allowed;
  color: white;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 12px;
  letter-spacing: -0.2px;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  padding: 0.5rem 1.5rem;
  outline: none;

  @media (max-width: 615px) {
    width: 48%;
  }
`;

export const StyledButtonDisabledBig = styled(ButtonDisabled)`
  font-size: 16px;
  height: 3rem;
  width: 88.22px;
`;

export const ButtonBig = styled(Button)`
  min-height: 40px;
  font-size: 16px;
  border-radius: 15px;
  min-width: 90px;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  align-items: ${(props) => (props.$flexStart ? "flex-start" : "center")};
  justify-content: center;
  min-height: ${(props) => (props.$open ? "270px" : "110px")};
  transition: all 0.3s ease-in-out;
`;

export const SearchRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  align-items: ${(props) => (props.$flexStart ? "flex-start" : "center")};
  justify-content: center;
  min-height: ${(props) => (props.$open ? "270px" : "40px")};
  transition: all 0.3s ease-in-out;
  @media (max-width: 738px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledRowOrg = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  align-items: ${(props) => (props.$flexStart ? "flex-start" : "center")};
  justify-content: center;
  min-height: ${(props) => (props.$open ? "270px" : "110px")};
  transition: all 0.3s ease-in-out;
  @media (max-width: 950px) {
    margin-top: 4rem;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  transition: all 0.3s ease-in-out;
  cursor: ${(props) => (props.$drag ? "grab" : "default")};
  @media (max-width: 946px) {
    margin-bottom: 2rem;
    flex-direction: column;
  }
  @media (max-width: 590px) {
    width: 100%;
  }
`;

export const StyledImage = styled(ProgressiveImg)`
  user-select: none;
  z-index: 400;
  border-radius: 50px;
  box-shadow: -2px 2px 30px 12px rgba(0, 0, 0, 0.25);
  @media (max-width: 615px) {
    width: 311px;
    height: 467px;
  }
  @media (max-width: 410px) {
    width: 259px;
    height: 409px;
  }
`;

export const ButtonStroke = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 30px;
  border-radius: 30px;
  user-select: none;
  border: 1px solid #fff;
  background: transparent;
  min-width: 234px;
  min-height: 61px;
  justify-content: center;

  cursor: pointer;
  color: #fff;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 22px;

  letter-spacing: 0.11px;
  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
  @media (max-width: 615px) {
    width: 48%;
    font-size: 18px;
  }
  @media (max-width: 410px) {
    font-size: 14px;
    min-height: 51px;
    min-width: 184px;
  }
`;

export const RightSide = styled.div`
  display: flex;
  position: relative;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  @media (max-width: 1100px) {
    align-items: center;
    justify-content: center;
  }
`;

export const RotateGiftIcon = styled.div`
  transform: ${(props) =>
    props.$ar ? "rotate(-18.884deg)" : "rotate(18.884deg)"};
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  align-self: flex-end;
`;

export const Gift = styled(GiftSvg)`
  height: 60px;
  width: 60px;
  @media (max-width: 410px) {
    height: 30px;
    width: 30px;
  }
`;

export const Image = styled.img`
  width: 357px;
  object-fit: contain;
  user-select: none;
  height: 337px;
  @media (max-width: 400px) {
    height: auto;
    width: 100%;
    aspect-ratio: 1 / 1;
  }
`;

export const Users = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 946px) {
    margin-top: 11rem;
  }
  @media (max-width: 590px) {
    width: 100%;
  }
`;
export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  min-height: 69px;
  width: 358px;
  cursor: pointer;
  border-radius: 12px;
  padding: 1rem 2rem;
  background: #fff;
  transition: all 0.3s ease-in-out;
  box-shadow: -3px 3px 5px 0px rgba(72, 72, 136, 0.1);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  &:hover {
    /* opacity: 0.75; */
    scale: 1.025;
  }

  @media (max-width: 420px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
  }
`;
export const OrgContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  min-height: 69px;
  width: 358px;
  cursor: pointer;
  border-radius: 12px;
  background: #fff;
  transition: all 0.3s ease-in-out;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  &:hover {
    /* opacity: 0.75; */
    scale: 1.025;
  }
`;

export const ProfilePhoto = styled.img`
  width: 5rem;
  height: 5rem;
  object-fit: cover;
  border-radius: 50%;
  user-select: none;
`;

export const OrhPhoto = styled.img`
  width: 14rem;
  height: 69px;
  object-fit: cover;

  border-radius: 0px 10px 0px 10px;
  user-select: none;
`;

export const WishlistName = styled.span`
  color: #85a1ac;
  font-family: "Avenir-Heavy";
  font-size: 18px;
  letter-spacing: -0.2px;
  @media (max-width: 420px) {
    text-align: center;
  }
`;

export const Username = styled.span`
  color: #85a1ac;
  font-family: "Avenir-Medium";
  font-size: 14px;
  letter-spacing: -0.2px;
  @media (max-width: 420px) {
    text-align: center;
  }
`;

export const SearchContainer = styled.div`
  width: 500px;
  transition: all 0.3s ease-in-out;
  @media (max-width: 738px) {
    width: 100%;
  }
`;

export const SearchListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: -3px 3px 5px 0px rgba(72, 72, 136, 0.1);
  border-radius: 0px 0px 15px 15px;
  border-left: 1px solid #85a1ac;
  border-right: 1px solid #85a1ac;
  border-bottom: 1px solid #85a1ac;
  overflow-y: auto;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  max-height: 230px;
  min-height: 70px;
  position: absolute;
  background-color: white;
  animation: ${(props) => (props.$open ? fadeIn : fadeOut)} 0.4s ease-in-out;
  width: 450px;
  @media (max-width: 738px) {
    width: 30rem;
  }
  @media (max-width: 350px) {
    width: 25rem;
  }
`;

export const SearchUser = styled.div`
  display: flex;
  flex-direction: row;
  width: 440px;
  align-items: center;
  gap: 1rem;
  min-height: 69px;
  border-radius: 12px;
  padding: 1rem 2rem;
  background: #fff;
  @media (max-width: 738px) {
    width: 29rem;
    flex-wrap: wrap;
    justify-content: center;

    /* flex-direction: column; */
  }
`;

export const NoProfilePhoto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #85a1ac;
  background-color: white;

  min-width: 5rem;
  min-height: 5rem;
  border-radius: 50%;
`;

export const IconGift = styled(GiftEmpty)`
  margin-left: -0.5px;
  margin-top: -0.5px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  gap: 1rem;
`;

export const StyledButtonDisabled = styled.button`
  display: flex;
  flex-direction: row;
  user-select: none;
  align-items: center;
  background: #85a1ac;
  box-shadow: ${(props) =>
    props.$noShadow
      ? "none"
      : "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;"};
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  min-width: 75px;
  height: 25px;
  gap: 1rem;
  justify-content: center;
  border: none;
  cursor: not-allowed;
  color: white;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 12px;
  letter-spacing: -0.2px;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  padding: 0.5rem 1.5rem;
  outline: none;

  &:active {
    box-shadow: none;
  }

  @media (max-width: 615px) {
    width: 48%;
  }
`;

export const ModalButton = styled.button`
  font-size: 1.8rem;
  font-family: "Avenir-Medium";
  letter-spacing: -0.2px;
  text-align: center;

  outline: none;
  color: white;
  user-select: none;
  height: 4.2rem;
  width: 6.2rem;
  cursor: pointer;
  border-radius: 3rem;
  background-color: ${(props) => (props.$yes ? "#c82333" : "#85a1ac")};

  transition: all 0.3s ease-in-out;
  border: 1px solid white;

  &:hover {
    background-color: #fff;
    color: black;
  }
`;
export const ModalText = styled.span`
  font-size: 1.8rem;
  font-family: "Avenir-Medium";

  letter-spacing: -0.2px;
  color: #c2d0d6;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.65);
  user-select: none;
  text-align: center;
`;
export const ModalTitle = styled.span`
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.65);
  font-size: 2.4rem;
  font-family: "Avenir-Heavy";

  letter-spacing: -0.2px;
  user-select: none;
  text-align: center;
  color: #c2d0d6;
`;

export const ModalRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export const BigButton = styled(ModalButton)`
  width: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
`;

export const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DescriptionInput = styled.textarea`
  width: 35rem;
  padding: 0.5rem 1.5rem;
  border-radius: ${(props) =>
    props.$borderRadius ? "15px 15px 0px 0px" : "1.5rem"};
  outline: none;
  border: 1px solid #85a1ac;

  height: 6.6rem;

  font-size: 1.4rem;
  transition: all 0.3s ease-in-out;
  font-family: "Avenir-Medium";

  @media (max-width: 420px) {
    width: 90% !important;
  }
`;

export const UserButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
